const LEADING_ITEM_NUMBER = /^\d+[.)]\s*/;

/** Compare a page title with a question, ignoring a leading item number such as "5. ". */
export function questionLabelKey(label: string | null | undefined): string {
    return (label ?? "").replace(LEADING_ITEM_NUMBER, "").replace(/\s+/g, " ").trim().toLowerCase();
}

/**
 * One question on the page, and the page title is that question again.
 * The field label already shows it, so the page heading would repeat it.
 */
export function pageLabelRepeatsQuestion(
    pageLabel: string | null | undefined,
    inputLabels: Array<string | null | undefined>
): boolean {
    const pageKey = questionLabelKey(pageLabel);
    if (!pageKey) return false;
    const questions = inputLabels.map(questionLabelKey).filter((label) => label.length > 0);
    return questions.length === 1 && questions[0] === pageKey;
}
